import { render, staticRenderFns } from "./XSwitch.vue?vue&type=template&id=1698fc15&scoped=true"
import script from "./XSwitch.vue?vue&type=script&lang=js"
export * from "./XSwitch.vue?vue&type=script&lang=js"
import style0 from "./XSwitch.vue?vue&type=style&index=0&id=1698fc15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1698fc15",
  null
  
)

export default component.exports